// Available string categories
export enum stringEnum {
    products = "products",
    harms = "harms",
    laws = "laws",
    jurisdiction = "jurisdiction",
}

// Available applications
export enum applicationEnum {
    grx = "grx",
    rac = "rac",
    appeals = "appeals",
    pForms = "pForms"
}


//Available agencies (GRX)
export enum agencyEnum {
    france = "france",
    germany = "germany",
}

// Available products
export enum productEnum {
    azure = "Azure",
    bing = "Bing",              
    bingSearch = "Bing Search",
    bingImageCreatorOrBingVideoCreator = "Bing Image Creator/Bing Video Creator",
    calendar = "Calendar",
    clipchamp = "Clipchamp",
    copilot = "Copilot AI Experiences",
    excel = "Excel",
    forza = "Forza",
    github = "GitHub",
    groupme = "GroupMe",
    linkedIn = "LinkedIn",
    loop = "Loop",
    mAdvertising = "Microsoft Advertising",
    mCommunity = "Microsoft Community",
    mDesigner = "Microsoft Designer",
    mFeedback = "Microsoft Feedback",
    mForms = "Microsoft Forms",
    mLearn = "Microsoft Learn",
    mLists = "Microsoft Lists",
    mMakecode = "Microsoft MakeCode",
    mPhotos = "Microsoft Photos",
    msn = "MSN",
    storesAPS = "Microsoft Store on Windows",
    storesWindows = "Microsoft Store Website",
    mTodo = "Microsoft To Do",
    mWhiteboard = "Microsoft Whiteboard",
    minecraft = "Minecraft",
    minecraftMarketplace = "Minecraft Marketplace",
    nugetGallery = "NuGet Gallery",
    onedrive = "OneDrive",
    onenote = "OneNote",
    outlook = "Outlook",
    powerpoint = "PowerPoint",
    sharepoint = "SharePoint",
    skype = "Skype",
    mStores = "Store Ratings and Reviews",
    surface = "Surface",
    sway = "Sway",
    teams = "Microsoft Teams",
    visio = "Visio",
    windows = "Windows",
    word = "Word",
    xbox = "Xbox",
    storesXboxCom = "Xbox.com",
    storesXboxConsole = "Microsoft Store on Xbox Console",
    storesXboxPC = "Xbox App on PC",
    storesXboxCloud = "Xbox Cloud Gaming for Web Store",
    maiPlayground = "MAI Playground",
}

// Available harms
export enum harmEnum {
    CSEA = "CSEA",
    TVEC = "TVEC",
    HateSpeech = "HateSpeech",
    SexualSolicitation = "SexualSolicitation",
    BullyingAndHarassment = "BullyingAndHarassment",
    SuicideAndSelfInjury = "SuicideAndSelfInjury",
    GraphicViolenceAndGore = "GraphicViolenceAndGore",
    NonConsensualImageryAndExtortion = "NonConsensualImageryAndExtortion",
    CoordinationOfHarm = "CoordinationOfHarm",
    ThreatsIncitementAndGlorificationOfViolence = "ThreatsIncitementAndGlorificationOfViolence",
    Trafficking = "Trafficking",
    Spam = "Spam",
    FraudPhishingOrScam = "FraudPhishingOrScam",
    VirusSpywareOrMalware = "VirusSpywareOrMalware",
    AdultAndSexual = "AdultAndSexual",
    Infringement = "Infringement",
    rac_CSEA = "rac_CSEA",
    rac_TVEC = "rac_TVEC",
    rac_HateSpeech = "rac_HateSpeech",
    rac_SexualSolicitation = "rac_SexualSolicitation",
    rac_BullyingAndHarassment = "rac_BullyingAndHarassment",
    rac_SuicideAndSelfInjury = "rac_SuicideAndSelfInjury",
    rac_GraphicViolenceAndGore = "rac_GraphicViolenceAndGore",
    rac_NonConsensualImageryAndExtortion = "rac_NonConsensualImageryAndExtortion",
    rac_CoordinationOfHarm = "rac_CoordinationOfHarm",
    rac_ThreatsIncitementAndGlorificationOfViolence = "rac_ThreatsIncitementAndGlorificationOfViolence",
    rac_Trafficking = "rac_Trafficking",
    rac_Spam = "rac_Spam",
    rac_FraudPhishingOrScam = "rac_FraudPhishingOrScam",
    rac_VirusSpywareOrMalware = "rac_VirusSpywareOrMalware",
    rac_AdultAndSexual = "rac_AdultAndSexual",
    rac_Infringement = "rac_Infringement",
    rac_RegulatedGoodsServices_AlcoholTobacco = "rac_RegulatedGoodsServices_AlcoholTobacco",
    rac_AlcoholTobaccoDrugs = "rac_AlcoholTobaccoDrugs",
    rac_ProfanityAndVulgarity = "rac_ProfanityAndVulgarity",
    rac_Grooming = "rac_Grooming",
    rac_EatingDisorders = "rac_EatingDisorders",
    rac_ExposureOfPersonalInformation = "rac_ExposureOfPersonalInformation",
    rac_FirearmsAndWeapons = "rac_FirearmsAndWeapons",
    rac_Extortion = "rac_Extortion",
    rac_OffTopic = "rac_OffTopic",
    rac_other = "rac_other",
    other = "other",
}

//Available laws (GRX)
export enum lawEnum {
    nz_fvpca = "nz_fvpca",
    eu_tcr = "eu_tcr",
    au_osa = "au_osa",
    au_bose = "au_bose",
    au_avm = "au_avm",
    us_ca_cmr = "us_ca_cmr",
    us_ca_cpa = "us_ca_cpa",
    us_ca_dsp = "us_ca_dsp",
    us_ca_ovpa = "us_ca_ovpa",
    sk_na = "sk_na",
    sk_tba = "sk_tba",
    in_ig = "in_ig",
    ph_osaec = "ph_osaec",
    ph_csaem = "ph_csaem",
    th_cca = "th_cca",
    notApplicable = "notApplicable"
}